var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<form ng-submit=\"$ctrl.submit()\"><modal modal-title=\"{{::$ctrl.title || 'Customer Cleanup'}}\" instance=\"$ctrl.modal\" on-dismiss=\"$ctrl.dismiss()\" on-close=\"$ctrl.close()\"><modal-body><customer-cleanup ng-if=\"$ctrl.options.retailerId\" retailer-id=\"{{$ctrl.options.retailerId}}\"></customer-cleanup></modal-body></modal></form>";
var id1="customer-cleanup-prompt.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;